import React from "react";

export default function SQLServer_REVERSE() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_REVERSE</h1>
      <p>This is the SQLServer_REVERSE component generated from the SQL JSON.</p>
    </div>
  );
}
